
import hheder from '../../components/HeaderHome/HeaderHome.vue'
export default {
  components: {
    hheder
  },

  data() {
    return {
      screen: {
        height: document.documentElement.clientHeight,
        width: document.documentElement.clientWidth
      },
      back:'',
      url:{
        GetSelectSalesUser: SZH.assets.api + '/Market/GetBackgroudImgs',
      },
      menus:[
        {
          name:'商城',
          url:'/',
          active:true,
          type:1,
          backgroundImg:'/static/images/HomeTH/home1.jpg'
        },
        {
          name:'交易大厅',
          url:'/HomeChare',
          active:false,
          type:2,
          backgroundImg:'/static/images/HomeTH/home2.jpg'
        },
        {
          name:'招标大厅',
          url:'/Menu/AuctionHallList',
          active:false,
          type:5,
          backgroundImg:'/static/images/HomeTH/home2.jpg'
        },
        {
          name:'竞采大厅',
          url:'/Menu/BidBuyList',
          active:false,
          type:5,
          backgroundImg:'/static/images/HomeTH/home2.jpg'
        },
        {
          name:'询价大厅',
          url:'/Menu/EnquiryList',
          active:false,
          type:5,
          backgroundImg:'/static/images/HomeTH/home2.jpg'
        },
        {
          name:'支持与服务',
          url:'/HomeSupport',
          active:false,
          type:3,
          backgroundImg:'/static/images/HomeTH/home3.jpg'
        },
        {
          name:'联系我们',
          url:'/HomeAbout',
          active:false,
          type:4,
          backgroundImg:'/static/images/HomeTH/home4.jpg'
        },
      ]
    }
  },
  methods: {
    JumpTo(item){
      this.$router.push({
        path:item.url
      });
      this.back = 'url(' + item.backgroundImg + ')';
    },
    initActive(){
      this.menus.forEach((it)=>{
        it.active = false;
        if(this.$route.path == it.url){
          it.active = true;
          this.back = 'url(' + it.backgroundImg + ')';
        }
      });
    },
    loadImgs(){
      var self = this;
      self.$http.post(self.url.GetSelectSalesUser,{
        keyValue:''
      }).then(result => {
        if (result.state == true && result.data &&result.data.length>0) {
            // 类型 1商城首页2交易中心3支持与服务4联系我们
          result.data.forEach(item=>{
            self.menus.forEach(it=>{
              if(item.F_Type == it.type){
                it.backgroundImg = SZH.assets.image +'/' + item.F_ImgUrl
              }
            })
          });
          self.initActive();
        } else {

        }
      },() => {
      });
    },
  },
  created() {
  },
  mounted() {


    const self = this;
    //初始化选中状态

    self.loadImgs();
    window.onresize = () => {
      return (() => {
        self.screen = {
          height: document.documentElement.clientHeight,
          width: document.documentElement.clientWidth
        }
      })();
    }
  },
  computed: {
    view() {
      return {
        height: this.screen.height,
        width: this.screen.width
      }
    },
  },
  watch: {
    $route(val) {
      this.menus.forEach((it)=>{
        it.active = false;
        if(val.path == it.url){
          it.active = true;
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/HomeTH/HomeTH.js